import styled from 'styled-components'

const Adornment = styled.div<{ disabled?: boolean }>`
  color: var(--gray600);
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--white);
  ${({ disabled }) => disabled && `background-color: var(--gray100);`}
`

export const FormLeftAdornment = styled(Adornment)`
  padding-left: 8px;
  border-radius: 8px 0 0 8px;
`
export const FormRightAdornment = styled(Adornment)`
  padding-right: 8px;
  border-radius: 0 8px 8px 0;
`
